import React, { useState, useMemo } from 'react';
import { Tabs, Space } from 'antd';
import { useDispatch } from 'react-redux';
import PortfolioTree from "../PortfolioTree";
import Comparison from "../../Comparison/Comparison";
import Placeholder from "../../../components/Placeholder";
import Spinner from "../../../components/Spinner";
import { initializeNewComparison } from "../../../store/slices/comparisonV2.slice";

const TreeView = ({ tree }) => {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('1');
    const [comparisonFetched, setComparisonFetched] = useState(false);

    // Recursive function to gather all unique IDs
    const gatherUniqueIds = (node) => {
        let ids = [];

        const gather = (currentNode) => {
            if (!currentNode) return;

            Object.entries(currentNode).forEach(([id, subNode]) => {
                ids.push(id); // Add the current ID
                if (subNode.tree) {
                    gather(subNode.tree); // Recursively gather from children
                }
            });
        };

        gather(node);
        return [...new Set(ids)]; // Remove duplicates using Set
    };

    // Memoized array of unique IDs
    const uniqueIds = useMemo(() => gatherUniqueIds(tree), [tree]);

    const handleTabChange = async (key) => {
        if (key === '2') {
            if (!comparisonFetched && uniqueIds.length > 0) {
                dispatch(initializeNewComparison(uniqueIds))
                setComparisonFetched(true);
                setActiveTab(key);

            }
        }
    };

    return (
        <Tabs activeKey={activeTab} onChange={handleTabChange} centered={true}>
            <Tabs.TabPane tab={'Tree'} key={'1'}>
                <PortfolioTree tree={tree} />
                <div>Unique IDs: {uniqueIds.join(', ')}</div> {/* Display unique IDs */}
            </Tabs.TabPane>
            <Tabs.TabPane tab={'Comparison'} key={'2'}>
                {comparisonFetched && <Comparison />}
                {!comparisonFetched && (
                    <Space>
                        <Spinner text={'Loading comparison'} />
                    </Space>
                )}
            </Tabs.TabPane>
        </Tabs>
    );
};

export default TreeView;
